module.exports = __webpack_public_path__ + "img/image 18.56011613.png";